import React from "react";
import OpenCloseItem from "../OpenCloseItem/OpenCloseItem";
import _ from "lodash";
import CustomLink from "../link/customLink";
import {ItemTypes} from "../../../helpers/variables";
import { DragSource, DropTarget } from 'react-dnd';

const rowSource = {
    beginDrag: (props) => {
        return { id: props.index, row: props };
    }
};

const rowTarget = {
    hover: (props, monitor) => {
        const draggedId = monitor.getItem().id;

        if (draggedId !== props.index) {
            // props.moveRow(draggedId, props.index);
        }
    },
    drop: (props, monitor, component) => {
        const draggedItem = monitor.getItem();
        if(props.onReorder){
            props.onReorder(draggedItem.row.datum, props.datum)
        }

        if(props.onReorderRow){
            const draggedId = monitor.getItem().id;

            if (draggedId !== props.index) {
                const rows = props.moveRow(draggedId, props.index);
                props.onReorderRow(rows);
            }

        }
    }
};

const sourceCollect = (connect, monitor) => {
    return {
        connectDragSource: connect.dragSource(),
        isDragging: monitor.isDragging()
    };
};

const targetCollect = (connect) => {
    return {
        connectDropTarget: connect.dropTarget()
    };
};

const ActionsCell = ({actions, datum, rowIndex}) => {
    return (
        <td>
            {
                actions.map((action, index) => {
                    if(action.customComponent){
                        const Comp = action.customComponent;
                        return <Comp key={index} datum={datum} action={action} rowIndex={rowIndex}/>
                    }
                    return (
                        <div key={index} >
                            <CustomLink
                                label={action.label}
                                onClick={action.callback? () => action.callback(datum, rowIndex) : null}
                                to={action.handleRedirect ? action.handleRedirect(datum) : null}
                            />
                        </div>
                    )
                })
            }
        </td>
    )
};

class CustomTableListRow extends React.Component {
    render(){
        const {
            selectable,
            columns,
            selected,
            onDatumSelect,
            hasActions,
            actions,
            expandableRow,
            onTableRowExpand,
            expandedTableRows,
            actionOnLeft,
            index,
            datum,
            connectDragSource,
            connectDropTarget,
            isDragging,
            isReorderable
        } = this.props;
        let opacity = isDragging ? 0 : 1;


        const Row = <tr
            key={1}
            className={`${(selectable && selected[index]) ? "row-selected" : ""}`}
            style={{ opacity }}
        >
            {[
                expandableRow && expandedTableRows ?
                    <td key={1}>
                        <OpenCloseItem
                            label={"toggle"}
                            onClick={() => onTableRowExpand(index)}
                            isOpen={!expandedTableRows.includes(index)}
                        />
                    </td> : null,
                selectable ?
                    <td className={"control-checkbox"} key={2}>
                        <input
                            type="checkbox"
                            name={`checkbox_${index}`}
                            checked={!!(selectable && selected[index])}
                            onChange={(evt) => onDatumSelect(evt.target.checked, index, datum)}
                        />
                    </td> : null,
                ...columns.map(column => (
                    <td key={column.propertyName}>
                        {
                            column.formatter ?
                                column.formatter(datum)
                                :
                                _.get(datum, column.propertyName)
                        }
                    </td>
                )),
                hasActions && !actionOnLeft ?
                    <ActionsCell key={3} actions={actions} datum={datum} rowIndex={index}/> : null

            ]}
        </tr>;

        if(isReorderable){
            return connectDragSource(connectDropTarget(
                Row
            ));
        } else {
            return Row
        }


    }
}

const source = DragSource(ItemTypes.CARD, rowSource, sourceCollect)(CustomTableListRow);
const DndRow = DropTarget(ItemTypes.CARD, rowTarget, targetCollect)(source);

export default DndRow;